export const CONTRACT_TYPE = {
    "LumpSum": 'L',
    "CostReimbursable": 'C'
}